import { RouteRecordRaw } from 'vue-router';

export const ewwmsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/EwWmsLayout.vue'),
    meta: { scope: 'ewwms', title: 'EW WMS' },
    children: [
      { path: '', name: 'ewwms.bestellungen', component: () => import('../pages/Bestellungen.vue') },
      { path: 'kommission/:id', name: 'ewwms.bestellung.versenden', props: true, component: () => import('../pages/BestellungVersenden.vue') },
      { path: 'umfuhren', name: 'ewwms.umfuhren', component: () => import('../pages/Umfuhren.vue') },
      { path: 'umfuhr/verladen/:id', name: 'ewwms.umfuhr.verladen', props: true, component: () => import('../pages/UmfuhrVersenden.vue') },
      { path: 'umfuhr/entladen/:id', name: 'ewwms.umfuhr.entladen', props: true, component: () => import('../pages/UmfuhrEntladen.vue') },
      { path: 'bestand', name: 'ewwms.bestand', component: () => import('../pages/Bestand.vue') },
      { path: 'artikel', name: 'ewwms.artikel', component: () => import('../pages/Artikel.vue') },
    ],
  },
];
